import * as types from '../../../../constants/ActionNameConstants';

// Dashboard Proofreader widget
export const dashboardProofreaderRequest = (params) => {
  return {
    type: types.GET_PROOFREADER_DASHBOARD_REQUEST,
    data: params,
  };
};

export const dashboardProofreaderSuccess = (payload) => ({
  type: types.GET_PROOFREADER_DASHBOARD_SUCCESS,
  payload,
});

export const dashboardProofreaderFailure = (error) => ({
  type: types.GET_PROOFREADER_DASHBOARD_FAILED,
  error,
});

export const resetDdashboardProofreader = () => {
  return {
    type: types.RESET_PROOFREADER_DASHBOARD,
  };
};

// File Reject
export const fileRejectRequest = (payload) => ({
  type: types.FILE_REJECT_REQUEST,
  payload,
});

export const fileRejectSuccess = (payload) => ({
  type: types.FILE_REJECT_SUCCESS,
  payload,
});

export const fileRejectFailure = (error) => ({
  type: types.FILE_REJECT_FAILED,
  error,
});
